import React, {useEffect, useRef, useState} from "react";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {useLocation} from "react-router-dom";
import {BannerRenderer} from "../../grid/BannerRenderer";
import {parseGridDocument} from "../../grid/serialization";
import {observeRenderReadiness} from "../../grid/render-readiness";
import {type GridDocument} from "../../grid/document";
import "../../App.css";
import "../../css/fonts.css";
import "./index.css";

declare global {interface Window {__GRID_RENDER_DOCUMENT__?: GridDocument;}}
function GridRender() {
  const root = useRef<HTMLDivElement>(null);
  const [document] = useState(() => window.__GRID_RENDER_DOCUMENT__ ? parseGridDocument(JSON.stringify(window.__GRID_RENDER_DOCUMENT__)) : null);
  useEffect(() => {
    if (!document) return;
    return observeRenderReadiness(root.current, () => {});
  }, [document]);
  return <div className="grid-render" ref={root} data-grid-render data-render-request={new URLSearchParams(window.location.search).get("request")}>
    {document?.banners.map((banner) => <section key={banner.instanceId} data-grid-card={banner.instanceId}>
      <BannerRenderer banner={banner} renderMode onChange={() => {throw new Error("Render documents are read-only");}} />
    </section>)}
  </div>;
}
export default function GridRenderRoot() {
  const [client] = useState(() => new QueryClient({defaultOptions: {queries: {retry: false}}}));
  const location = useLocation();
  return <QueryClientProvider client={client}><GridRender key={location.key} /></QueryClientProvider>;
}
